import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryAssignRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = MenuCategoryAssignRequestSchema.strict()

const normalize = fieldNormalizer({ intList: ['category_ids'] })

export const MenuCategoryAssign = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    const categoryIds = value.category_ids ?? []
    const seen = new Map<number, number>()
    categoryIds.forEach((id) => seen.set(id, (seen.get(id) ?? 0) + 1))
    categoryIds.forEach((id, index) => {
      if ((seen.get(id) ?? 0) > 1) {
        issues.addIssue({
          code: 'custom',
          message: 'Duplicate categories are not allowed',
          path: ['category_ids', index]
        })
      }
    })
  })
